import { Link } from "react-router-dom";
import type { Special } from "@/mocks/specials";
import SectionHeading from "@/components/feature/SectionHeading";

interface FeaturedReviewsProps {
  specials: Special[];
}

export default function FeaturedReviews({ specials }: FeaturedReviewsProps) {
  if (specials.length === 0) {
    return (
      <div className="py-16 text-center text-foreground-500 text-sm">暂无影评推荐，敬请期待</div>
    );
  }

  return (
    <section>
      <SectionHeading
        title="热门影评推荐"
        subtitle="来自编辑部的深度解读，帮你更懂一部作品"
        moreTo="/special"
        moreLabel="全部专题"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {specials.map((special) => (
          <Link
            key={special.id}
            to={`/special/${special.id}`}
            className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-colors cursor-pointer flex flex-col"
          >
            <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
              <img
                src={special.cover}
                alt={`${special.title} 专题封面`}
                title={`${special.title} - 影评专题`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-medium">
                专题
              </span>
            </div>
            <div className="p-4 flex flex-col flex-1">
              <h3 className="font-heading font-bold text-base text-foreground-950 group-hover:text-primary-500 transition-colors">
                {special.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                {special.intro}
              </p>
              <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i>
                  {special.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-file-list-3-line"></i>
                  {special.articles.length} 篇长评
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}